const userInputs = [
     {
      id: "Full Name",
      label: "Full Name",
      type: "text",
      placeholder: "eg. Gopal Verma",
    },
    {
      id: "Description",
      label: "Description",
      type: "text",
      placeholder: "eg. Instrument decription",
    },
    {
      id: "displayName",
      label: "Instrument Name",
      type: "text",
      placeholder: "eg. Tracter, Harvester",
    },
    {
      id: "email",
      label: "Email",
      type: "mail",
      placeholder: "john_doe@gmail.com",
    },
    {
      id: "phone",
      label: "Phone",
      type: "text",
      placeholder: "+91 234 567 89",
    },
    {
      id: "password",
      label: "Password",
      type: "password",
    },
    {
      id: "address",
      label: "Address",
      type: "text",
      placeholder: "Wagholi, Pune",
    },
    {
      id: "Price",
      label: "Cost per day",
      type: "text",
      placeholder: "eg. 100rs",
    },
  ];
  export default userInputs;  